import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { EncryDecryService } from 'src/app/core/encry-decry.service';
import { PasswordValidator } from 'src/app/validator/password-validator';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.component.css']
})
export class RecoveryPasswordComponent implements OnInit {

  resetPwdForm: FormGroup;
  isLoadingResults = false;
  submitted = false;
  msg: string = null;
  showdata = false;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private cryptoService: EncryDecryService
  ) { }

  ngOnInit(): void {
    this.resetPwdForm = this.formBuilder.group({
      'emailAddress': [null],
      'password': [null, [Validators.required, Validators.minLength(8)]],
      'confirmPwd': [null, Validators.required]
    }, {
      validator: PasswordValidator.comparePasswords
    });
    this.route.queryParams.subscribe(params => {
      this.validateRequest(params['query']);
    });
  }

  validateRequest(query) {
    this.authenticationService.validate(query).subscribe(data => {
      if (data != undefined && data["statusCode"] == 200) {
        this.showdata = true;
        this.resetPwdForm.patchValue({
          emailAddress: data["result"]["email"]
        });
      }
      else {
        this.showdata = false;
        this.msg = "link has expired.";
      }
    }, (err) => {
      this.showdata = false;
      this.msg = "link has expired.";
    });
  }

  onFormSubmit() {
    this.isLoadingResults = true;
    this.authenticationService.resetPassword(this.resetPwdForm.get("emailAddress").value, this.cryptoService.Encrypt(this.resetPwdForm.get("password").value)).subscribe(res => {
      if (res != undefined && res["statusCode"] == 200) {
        this.isLoadingResults = false;
        this.toastr.success('Password has been reset successfully.');
        this.router.navigate(['/login'])
      }
      else {
        this.isLoadingResults = false;
        this.toastr.error("Please try again.", 'Error');
      }
    }, (err) => {
      this.toastr.error(err, 'Error');
      this.isLoadingResults = false;
    });
  }


}
